export const CONST = {
  // BACKEND_URL: 'http://localhost:5205/api/dadmin',
  BACKEND_URL: 'https://orcha.jamsara.com/api/dadmin',

};